import { useState, useEffect } from "react";
import { Lightbulb } from "lucide-react";

export const FactsCycler = () => {
  const [currentFactIndex, setCurrentFactIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const facts = [
    <p>UK organisations with £36m+ turnover must publish an annual Modern Slavery Statement detailing their anti-slavery steps.</p>,
    <p>A statement isn't just paper; it needs board approval and a director's signature to be legally compliant.</p>,
    <p>Strong statements go beyond listing policies; they show how policies are actively used and enforced day-to-day.</p>,
    <p>Measuring real impact (like fewer worker complaints resolved) is stronger than just counting training sessions held (outputs vs. outcomes).</p>,
    <p>Identifying <b>specific</b> risks (like migrant worker exploitation in a particular region) is more effective than generic anti-slavery statements.</p>,
    <p>Looking beyond direct suppliers (Tier 1) is crucial, as major risks often lie deeper in the supply chain.</p>,
    <p>Vague language is a red flag. Impactful statements provide concrete details on actions, challenges, and progress.</p>,
    <p>Truly effective grievance mechanisms allow workers to report concerns safely and in their own language.</p>,
    <p>Transparency matters: acknowledging identified risks and explaining the response is often better than claiming a risk-free operation.</p>
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);

      setTimeout(() => {
        setCurrentFactIndex((prev) => (prev + 1) % facts.length);
        setIsTransitioning(false);
      }, 500); // Half of the transition time
    }, 8000);

    return () => clearInterval(interval);
  }, [facts.length]);

  return (
    <div className="max-w-xl rounded-3xl border border-[rgba(31,76,84,0.12)] bg-white/85 p-6 shadow-[0_18px_30px_rgba(15,23,42,0.08)] backdrop-blur">
      <div className="mb-4 flex items-center gap-3">
        <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-[rgba(31,76,84,0.08)] text-[var(--accent)]">
          <Lightbulb className="h-5 w-5" />
        </span>
        <h3 className="eyebrow-muted">
          Insight
        </h3>
      </div>
      <div
        className={`text-sm leading-relaxed text-[var(--text-secondary)] transition duration-500 ease-out ${
          isTransitioning ? "translate-y-[-8px] opacity-0" : "translate-y-0 opacity-100"
        }`}
      >
        {facts[currentFactIndex]}
      </div>
    </div>
  );
};

export default FactsCycler;
